class SocialCampaign {
  // `false` if it was added to a profile implicitly through a social plan
  // BUT is not implicitly part of the current social plan
  constructor({
    type,
    name,
    description,
    enabled,
    contentFilterParams,
    contentType,
    active
  }) {
    this.type = type;
    this.name = name;
    this.description = description;
    this.enabled = enabled;
    this.contentFilterParams = contentFilterParams;
    this.contentType = contentType;
    this.active = active;
  }

} // eslint-disable-next-line arrow-body-style


SocialCampaign.parse = (json
/*: Object*/
) =>
/*: SocialCampaign*/
{
  return new SocialCampaign({
    type: json.type,
    name: json.name,
    description: json.description,
    enabled: json.enabled,
    contentFilterParams: json.contentFilterParams,
    contentType: json.contentType,
    active: json.active
  });
}; // eslint-disable-next-line arrow-body-style


SocialCampaign.serialize = (data
/*: SocialCampaign*/
) =>
/*: Object*/
{
  return {
    enabled: data.enabled
  };
};

module.exports = SocialCampaign;